import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import mutations from './mutations'
// import modules from './modules'
import actions from './actions'
import getters from './getters'
Vue.use(Vuex)

// Create a new store
const store = new Vuex.Store({
  strict: true,
  actions,
  getters,
  // modules,
  mutations,
  state
})

export default store